import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import chromium from "../../Assets/Projects/chromium.gif";
import gta from "../../Assets/Projects/gta.png";
import fake from "../../Assets/Projects/fake.png";
import vanguard from "../../Assets/Projects/vanguard.png";
import discord from "../../Assets/Projects/discord.png";
import webshop from "../../Assets/Projects/webshop.png";
import storagemanager from "../../Assets/Projects/storagemanager.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="lime">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently. Many of them are private, but there is still a lot to come online.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chromium}
              title="ChromiumForWindows"
              description="A Chromium installer and auto updater for Windows. Chromium is an open source variant of Chrome, but sadly, it does not include a built in updater. Therefore, the app aims to check the latest updates, thus includes features like choosing different Chromium builds, each having a unique benefit. One of the most famous variant is the ungoogled build which removes Google's tracking elements from the browser. The updater is also recommended by the popular Chromium related forum https://chromium.woolyss.com/"
              ghLink="https://github.com/iklevente/ChromiumForWindows"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gta}
              title="GTA Online Solo Session Creator"
              description="Creates a solo public session, so you can invite your friends and do supplies without being interrupted by enemy players. It works by freezing your game for some seconds, so you can disconnect from your current lobby and get into a new empty lobby. There, you can invite your friends and play without modders, annoying players, etc.. The aim of the project was to get a better understanding of system level thread handling."
              ghLink="https://github.com/iklevente/GTA-Online-Solo-Session-Creator"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fake}
              title="Login Panel Flooder with Fake Credentials"
              description="A program to spam a fake login panel with randomly generated emails and passwords. I made this program to spam a Steam account stealer site. I spamming them over 1000 tries made the site completely offline. Can be a fun and helpful experience if you are about to get scammed."
              ghLink="https://github.com/iklevente/Fake-LoginPanel-Flooder"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vanguard}
              title="Vanguard Ducker"
              description="A simple tool to disable the Vanguard anti-cheat running in the background. The anti-cheat is famous for being unique by having kernel level access to your computer and running at system startup every time you start your computer. This made many people furious, not just because it has access to all of your data, but because it still eating up resources even though you haven't started playing the game. This tool helps you easily turn it off for good, and turn it back on whenever you have the mood for some more Valorant."
              ghLink="https://github.com/iklevente/VanguardDucker"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={discord}
              isDonate={true}
              title="WebhookDiscordTokenGrabber"
              description="A .NET script that is able to find the user's Discord authentication token and send it to your Discord server through a given webhook URL. With the authentication token you can log in to the victim's account and have user-level access like reading and sending messages. The code is now considered as malicious by most antivirus, but it gives you a clear understanding of how it works. It is not publicly available as it can be used for malicious purposes. (Maybe not in current form, because it's well known by AVs) and that is the only reason why I decided to still distribute it, but only for a small amount of donation so it doesn't get into everybody's hands. If you need it, please buy me a beer and leave a note asking for the software, including your email address so I can reply to you. Use it for educational purposes only."
              donateLink="https://revolut.me/iklevi"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={webshop}
              title="evoWebShop"
              isDonate={true}
              description="A functional webshop that I took part in building with a team of university students at a Siemens company. I have gained a better understanding of building React and C# Rest API solutions, which utilize MSSQL. Additionally, I have also learned cookie handling, how to implement multiple dynamic search filters, and a login system that is capable of salted password hashing and can be used with external OAuth applications. Unfortunately, the project is not available to the public because it was developed within an internal environment by our team."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={storagemanager}
              title="evoStorageManager"
              isDonate={true}
              description="A storage management software that I took part in building with a team of university students at a Siemens company. I have learned the MVVM pattern and successfully created a frontend for our backend application, which also relies on a C# Rest API. Unfortunately, the project is not available to the public because it was developed within an internal environment by our team."
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
